import React, {useState} from "react";
import { connect } from "react-redux";
// import { Table } from "reactstrap";
import { Col, Card, CardHeader, CardBody, CardText, Dropdown, DropdownMenu, DropdownItem, DropdownToggle } from "reactstrap";
import { Line, Bar } from "react-chartjs-2";
import "chart.js/dist/Chart.css"; 
class MesurementItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dropdownOpen: false,
      currentIndex: 0
    };
  }

  render() {
    const { item } = this.props;
    const { dropdownOpen,currentIndex } = this.state;
    const toggle = () => this.setState({ dropdownOpen: !this.state.dropdownOpen });
    const monthArray = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const currentData = item[currentIndex];
    console.log("Items List => ", item, "Current Data => ", currentData);
    const heightList = monthArray.map((mon, i) => {
      let monIndex = currentData.data.findIndex(ele => monthArray[ele.month] === mon);
      if (monIndex >= 0) {
        return currentData.data[monIndex].height;
      } else return 0;
    });
    const weightList = monthArray.map((mon, i) => {
      let monIndex = currentData.data.findIndex(ele => monthArray[ele.month] === mon);
      if (monIndex >= 0) {
        return currentData.data[monIndex].weight;
      } else return 0;
    });
    // currentData.data.map((data) => {
    //   let hgt = [];
    //   if (monthArray.findIndex(ele => ele == monthArray[data.month]) >= 0) {
    //     return data.height;
    //   }
    // })
    console.log("Height => ", heightList);
    const data = {
      labels: monthArray,
      datasets: [
        {
          label: "Height (cm)",
          data: heightList,
          borderColor: "rgba(255, 99, 132, 1)",
          backgroundColor: "#21c1e0",
          fill: false,
        },
        {
          label: "Weight (kg)",
          data: weightList,
          borderColor: "rgba(54, 162, 235, 1)",
          backgroundColor: "#01579b",
          fill: false,
        },
      ],
    };
    const onClickHandler =(year)=>{
      let index= item.findIndex((ele)=>ele.year==year);
      console.log("Change : ",index);
      if(index >= 0) this.setState({ currentIndex : index, dropdownOpen : false });
    }
    console.log("Measurement index => ",currentIndex,"Current Array => ", item[currentIndex]);
    console.log("DATA => ", data);
    return (
      <Col>
        <Card className="my-3 border-0 shadow">
          <CardHeader
            className="text-white"
            style={{ fontFamily: "Baloo", background: "#00BFA5" }}
          >
            <i className="icon-calender fs-16"></i>{" "}
            <Dropdown isOpen={dropdownOpen} toggle={toggle} style={{cursor:'pointer'}}>
              <DropdownToggle caret size="lg" data-toggle="dropdown" tag="span">
                {item[currentIndex].year}
              </DropdownToggle>
              <DropdownMenu>
                {item.map((ele) => (
                  <DropdownItem
                    key={ele.year}
                    onClick={() => onClickHandler(ele.year)}
                  >
                    {ele.year}
                  </DropdownItem>
                ))}
              </DropdownMenu>
            </Dropdown>
          </CardHeader>
          <CardBody className="mobile-padding">
            {/* <CardText>Height : {item.height} cm</CardText>
            <CardText>Weight : {item.weight} kg</CardText> */}
            {/* <Line
              data={data}
              options={{
                scales: {
                  y: {
                    beginAtZero: true,
                  },
                },
              }}
            /> */}
            <Bar
              options={{
                responsive: true,
                scales: {
                  y: {
                    beginAtZero: true,
                  },
                },
                maintainAspectRatio:false
              }}
              data={data}
            />
          </CardBody>
        </Card>
      </Col>
    );
  }
}
const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({});
export default connect(mapStateToProps, mapDispatchToProps)(MesurementItem);
